import Markdown from "components/markdown/markdown";

export default function Headline({
  headline,
  subhead,
}: {
  headline: string;
  subhead: string;
}) {
  return (
    <div className="mb-[15px] md:mb-[70px] lg:mb-10">
      {headline && (
        <Markdown
          className="mb-[12px] font-recklessBold text-[32px] leading-[130%] md:mb-5 md:text-[52px] lg:mb-[12px]"
          text={headline}
        />
      )}
      {subhead && (
        <Markdown
          className="text-sm text-mono-70 md:text-[16px]"
          text={subhead}
        />
      )}
    </div>
  );
}
